export default "__VITE_ASSET__Qoyn8OoS__"